import _ from 'lodash';
import React from 'react';
import i18next from 'i18next';
import CalculatorSelectInput from '../../../../calculatorInputs/CalculatorSelectInput';
import CalculatorMultipleValueInput from '../../../../calculatorInputs/CalculatorMultipleValueInput';
import { REGEXP_DECIMAL } from '../../../../../../../../services/common/Constants';
import { useFormContext } from 'react-hook-form';

const SetValue = ({ fieldName, showLabel, validateValue, availableValueOptions, readOnly = false }) => {
  const { setError, clearErrors } = useFormContext();

  const label = showLabel ? i18next.t('calculator.dialog.create.label.values') : '';
  const placeholder = i18next.t('calculator.dialog.create.placeholder.selectValues');

  const validate = (value) => {
    if (!value) {
      clearErrors(fieldName);
      return true;
    }

    if (!REGEXP_DECIMAL.test(value)) {
      setError(fieldName, {
        type: 'manual',
        message: i18next.t('attributes.errors.decimal'),
      });
      return false;
    }

    clearErrors(fieldName);
    return true;
  };

  const commonProps = {
    fieldName: `${fieldName}${!_.isEmpty(availableValueOptions) ? '.0' : ''}`,
    label,
    placeholder,
    isRequired: true,
    uxVariant: 'criteriaInput',
    validate: !_.isEmpty(availableValueOptions) ? validateValue : validate,
    variant: 'standard',
  };

  return !_.isEmpty(availableValueOptions) ? (
    <CalculatorSelectInput
      {...commonProps}
      options={availableValueOptions}
      labelVariant="chip"
      triggerOnContinue
      disabled={readOnly}
    />
  ) : (
    <CalculatorMultipleValueInput {...commonProps} triggerOnContinue disabled={readOnly}/>
  );
};

export default SetValue;
